import type { ClikArtCmsKeyword } from '@/api/types/clikart'

/**
 * `SearchKeywordComboBox` (and the badges below it) work in terms of keyword NAMES, matching
 * every other combobox in this panel — the server's `/clikart/search?keywordIds=` param wants
 * ids. Resolves the selected names against the fetched keyword list; a name with no match (e.g.
 * the keyword list hasn't loaded yet) is dropped rather than sent as a bogus id.
 */
export function resolveClikArtKeywordIds(
  selectedNames: string[],
  keywords: ClikArtCmsKeyword[]
): number[] {
  if (selectedNames.length === 0) return []

  const idByName = new Map(
    keywords.map((keyword) => [keyword.cmsKeywordName, keyword.cmsKeywordId])
  )

  return selectedNames
    .map((name) => idByName.get(name))
    .filter((id): id is number => id !== undefined)
}
